<template>
    <div class="filterItem" v-show="value.filter">
         <div>
           
            <h1 class="title is-6">
              
                &nbsp;&nbsp;{{value.label}} : 
                <div style="float: right" v-if="value.valuesDefault!=null">
                    <s-button @onclick="enabledFilter(value)" 
                        theme="is-warning is-small" 
                        label="Désactiver ce critère"
                        icon="trash"
                    />
                </div>
            </h1>
        </div>
        <div>
           
        <div v-if="value.type=='radio' || value.type=='checkbox'">
         
            <div style="padding-left:10px;display:inline-block"
                v-for="(valueItem, indexValue) in value.values">
                <label class="radio"  v-if="value.type=='radio'">
                    <input  :name="value.id" :type="value.type" 
                    v-model="value.valuesDefault" 
                    :value="indexValue"  
                    :disabled="disabled"
                    />
                    &nbsp;&nbsp;&nbsp;<span style="font-size:17px">{{valueItem}}</span>
                </label>
                <label class="checkbox"  v-if="value.type=='checkbox'">
                    <input :name="value.valueItem" :type="valueItem.type"
                    v-model="valueItem.valuesDefault"  :value="indexValue" :disabled="disabled"  />
                    &nbsp;&nbsp;&nbsp;<span style="font-size:17px">{{valueItem}}</span>
                
                </label>
            </div>
        </div>
        <div  v-if="value.type!='radio'">
            <label class="select is-warning is-rounded is-normal">
            <select v-model="value.operator">
               
                <option value=">">Supérieur à</option>
                <option value="<">Inférieur à</option>
                <option value="=">Egale à</option>
            </select>
            </label>
            <input :type="value.type" v-model="value.valuesDefault"
                class="input is-rounded is-warning" style="width:200px"
                :disabled="disabled"
                />
        </div>
        </div>
    </div>
</template>
<style scoped>
    .filterItem {
        padding: 10px;
    }
    .filterItem:nth-child(even) {
        background-color: antiquewhite;
    }
    .filterItem:nth-child(odd) {
        background-color: rgb(233, 230, 227);
    }
</style>
<script>
export default {
    props:["value", "disabled"],
    methods : {
        enabledFilter(filter) {
         
            filter.valuesDefault = null;
        }
    },
    mounted() {
        
    }
}
</script>